import React, { useState } from 'react';
import { useSwipeable } from 'react-swipeable'
import styles1 from './carousel.module.css'
import styles from './earlybenefit.css'
import arrow_prev  from '../../../assets/eb-arrow-r.svg'
import arrow_next  from '../../../assets/eb-arrow.svg'
import { Card, CardBody,Container } from 'reactstrap';
import DownArrow from 'assets/down-arrow.svg' 
import UpArrow from 'assets/up-arrow.svg' 
import NeetPrep from 'assets/neet_audiprep.svg' 
import Mocktest from 'assets/mocktest_icon.svg'
import experimentalvideo from 'assets/experimentalvideo_icon.svg'
import jeechallenger from 'assets/jeechallenger_icon.svg' 
import knowledgebytes from 'assets/knowledgebytes_icon.svg' 
import neetchallenger from 'assets/neetchallenger_icon.svg' 
import rapidrevision from 'assets/rapidrevision_icon.svg' 
import recordedvideo from 'assets/recordedvideo_icon.svg' 
import shortmotivational from 'assets/shortmotivational_icon.svg' 
import weeklyquiz from 'assets/weeklyquiz_icon.svg' 
import {trackWebEngageEvent, params as webengage_params} from '../../../utils/customWebengageEvents'


export const NEXT = 'NEXT'
export const PREV = 'PREV'

const getOrder = (index, pos, numItems) => {
    return index - pos < 0 ? numItems - Math.abs(index - pos) : index - pos
}
const getInitialState = (numItems) => ({
    pos: numItems - 1,
    sliding: false,
    dir: NEXT,
})
 const Domain = window.location.hostname
    const isAkTheDomain = Domain.includes('akthedashboard');
function EarlyBenefits({ response, staticData }) {
    const [isOpen, setIsOpen] = useState(false);

    const toggleDiv = () => {
        setIsOpen(!isOpen);
        trackWebEngageEvent(isAkTheDomain?'AKTHE_db_pr_view_benefits':'Anthe_db_pr_view_benefits',webengage_params);
    };
    
    response=[{img_url:NeetPrep},{img_url:Mocktest},{img_url:experimentalvideo},{img_url:jeechallenger},{img_url:knowledgebytes},{img_url:neetchallenger},{img_url:rapidrevision},{img_url:recordedvideo},{img_url:shortmotivational},{img_url:weeklyquiz}]
    const numItems = response.length

    const [state, dispatch] = React.useReducer(reducer, getInitialState(numItems))

    const slide = (dir) => {
        dispatch({ type: dir, numItems })
        setTimeout(() => {
            dispatch({ type: 'stopSliding' })
        }, 50)
    }

    const handlers = useSwipeable({
        onSwipedLeft: () => slide(NEXT),
        onSwipedRight: () => slide(PREV),
        swipeDuration: 500,
        preventScrollOnSwipe: false,
        trackMouse: true,
    })
   
    return (
        <>
        <button onClick={toggleDiv} className="toggle-button border-0 bg-none text-center text-aqua font-size-sm fw-lighter p-2 p-lg-0">
        {isOpen ? 'Hide Benefits' : 'View Benefits'} 
        <img 
            src={isOpen ? UpArrow : DownArrow} 
            alt="toggle arrow" 
            className="arrow-icon"
        />
         </button>
          {isOpen && (
            <Container className="px-lg-0 px-xl-0 px-3 pb-lg-0 pb-xl-3 mh-100 maxw-11 pb-lg-0 pb-3">
            <Card className="details-div border-0">
                <CardBody className='pe-0 pe-md-3 pb-0 p-0 ps-lg-3 pt-lg-3'>
                  <h2 className='font-size-lg text-color fw-lighter '>Early Admission Benefits</h2>
                  <div {...handlers} className={`${styles1.carouselCard} p-0 pb-0`}>
                  <div {...handlers} className={`${styles1.main_slide}`}>
                  <div className={`${styles1.slide_btn} d-flex justify-content-between d-none d-xl-block `}>
                      <button onClick={() => slide(PREV)} className={`${styles1.slide_prev}`}><img src={arrow_prev}/></button>
                      <button onClick={() => slide(NEXT)} className={`${styles1.slide_next}`}><img src={arrow_next}/></button>
                      </div>
                      <div className={`${styles1.wrapper}`}>
                        <div className='d_desktop'>
                            <div className="d-flex">
                                {response.map((cardDetails, index) => (
                                    <div
                                        className={`${styles1.carouselSlot} mb-3`}
                                        key={index}
                                        style={{
                                            transition: state.sliding
                                                ? 'none'
                                                : 'transform .7s ease',
                                            transform: !state.sliding
                                                ? 'translateX(calc(-97% - 20px))'
                                                : state.dir === PREV
                                                ? 'translateX(calc(2 * (-90% -50px)))'
                                                : 'none',
                                                
                                            order: getOrder(index, state.pos, numItems),
                                        }}
                                    >
                                        <img src={cardDetails.img_url} />
                                    </div>
                                ))}
                            </div>
                          </div>
                          <div className="d_mobile">
                            <div className="d-flex d_mobile scroll_mobile">
                            {response.map((cardDetails, index) => (
                                 <div key={index} className='scroll_slider'>
                                      <img src={cardDetails.img_url} />
                                </div>
                                
                              ))}
                          </div>  
                          </div>
                          {/* <div className="d-flex d-md-none">
                              {response.map((_, index) => {
                                  const activeSlide =
                                      index % 2 === 0
                                          ? numItems - (state.pos + 1)
                                          : state.pos + 1
                                  return (
                                      <span
                                          key={index}
                                          style={{
                                              height: '6px',
                                              width:
                                                  activeSlide !== index ? '6px' : '24px',
                                          }}
                                          className={`d-block me-1 bg-aqua rounded`}
                                      />
                                  )
                              })}
                          </div> */}
                      </div>
                     
                  </div>
              </div>
                </CardBody>
            </Card>
            </Container>
        )}
        </>
    )
}

function reducer(state, action) {
    switch (action.type) {
        case PREV:
            return {
                ...state,
                dir: PREV,
                sliding: true,
                pos: state.pos === 0 ? action.numItems - 1 : state.pos - 1,
            }
        case NEXT:
            return {
                ...state,
                dir: NEXT,
                sliding: true,
                pos: state.pos === action.numItems - 1 ? 0 : state.pos + 1,
            }
        case 'stopSliding':
            return { ...state, sliding: false }
        default:
            return state
    }
}

export default EarlyBenefits
